import React from 'react';
import Sectiontitle from './sectiontitle';
import Smalltitle from './smalltitle';
import Skill from './skill';
import Resume from './resume';

import useSkill from '../hooks/use-skill';
import useEmpleo from '../hooks/use-empleo';
import useEducacion from '../hooks/use-educacion';

import TrackVisibility from "react-on-screen";

const Resumes = () => {

    const skills = useSkill();
    const empleos = useEmpleo();
    const educaciones = useEducacion();

    return (
        <>
        <section id="resume" className="bg-light">
            <div className="mi-skills-area mi-section pt-5">
                <div className="container">
                    <Sectiontitle title="My Skills" />
                    <div className="mi-skills">
                        <div className="content-skills mb-3">
                            <span>Basic</span>
                            <span>Medium</span>
                            <span>Advanced</span>
                        </div>
                        <div className="row mt-30-reverse">
                            {skills.map(skill => (
                                <TrackVisibility once className="col-lg-6 mt-30" key={skill.nombre}>
                                    <Skill 
                                        nombre={skill.nombre} porcentaje={skill.porcentaje} nivel={skill.nivel}
                                    />
                                </TrackVisibility>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="mi-resume-area mi-section py-5">
                <div className="container">
                    <Sectiontitle title="Resume" />
                    <Smalltitle title="Working Experience" icon="briefcase" />
                    <div className="mi-resume-wrapper">
                        {empleos.map(empleo => (
                            <Resume 
                                key={empleo.titulo}
                                resumeData={empleo}
                            />
                        ))}
                    </div>
                    <div className="mt-30"></div>
                    <Smalltitle title="Educational Qualifications" icon="book" />
                    <div className="mi-resume-wrapper">
                        {educaciones.map(educacion => (
                            <Resume 
                                key={educacion.titulo}
                                resumeData={educacion}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
        </>
    );
}

export default Resumes;